'use strict';
declare var loaderConfigSalETF: any;
module Patersons {

    export interface  EtfReportScope extends ng.IScope {
        isLoading: boolean;
        securityId: string;
    }

    export class EtfReportCtrl extends AbstractController {
        scope: Patersons.EtfReportScope;
        timeout: any;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.scope.securityId = $stateParams.secId;
            this.timeout = $timeout;
            this.load();
        }

        load() {

            this.log.info("SAL report Ctrl loading...");
            console.log($('#sal-report'))
            //
            var isinData = this.state.params['secId']
                ? this.state.params['secId']
                : "";
            if (isinData) {
                $.ajax(SALauthUrl).then(function (authData) {
                    loaderConfigSalETF.configuration.overrides.settings.shareClassId = isinData;
                    loaderConfigSalETF.apiTokens.apiGatewayToken = authData.body;
                    $('#SalContainer').data('$injector', '')
                    morningstar.loader.load(loaderConfigSalETF).then(function() {
                        $('#main-spinner').remove()
                    }).catch(function (error) {
                        console.log(error);
                    });

                })
            } else {
                this.state.go('dashboard')
            }
        }
    }
}
